import React from 'react'
import TicketItem from '../TicketItem'

import './index.scss'
function List({ listData, curFeedbackId, submitComment }: { listData: any[]; curFeedbackId: any; submitComment: any }) {
  return (
    <div className='c-ticket-scroll-list'>
      {listData.map((item) => (
        <TicketItem itemData={item} key={item._id} curFeedbackId={curFeedbackId} submitComment={submitComment} />
      ))}
    </div>
  )
}
export default List
